module.exports = __webpack_public_path__ + "img/trial2-4.1d49c504.png";